import apiClient from './client';

export const timetableApi = {
  getWeekly: (params?: {
    location_id?: string;
    coach_id?: string;
    day?: string;
    target_date?: string;
  }) => apiClient.get('/classes/timetable/weekly', { params }).then((r) => r.data),
};
